import { NavigableButton } from '@carvana/ds-button';
import TradeIn from '@carvana/ds-icons/TradeinSpot';
import { icon } from '@carvana/ds-styles';
import TrackWrapper from '@/common/TrackWrapper';
import formatEvent from '~/utilities/formatEvent';
import {
  DefaultCardContainer,
  DefaultCardContent,
  DefaultCardHeading,
  DefaultCardBody
} from './SharedCard.styles';

type OwnProps = {
  ctaHref: string;
  dataNativeIncluded?: boolean;
  dataNativePayload?: string;
  onClick?: (
    ev: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>
  ) => void;
};

export default function DefaultTradeCard({
  ctaHref,
  dataNativeIncluded,
  dataNativePayload,
  onClick
}: OwnProps) {
  const commonCustomAttributes = {
    description: 'STC card',
    status: 'default',
    cta: 'get your offer'
  };

  return (
    <TrackWrapper
      event={formatEvent('Home feed card', {
        action: 'viewed',
        ...commonCustomAttributes
      })}
      trackOnce
      key="trade-default"
    >
      <DefaultCardContainer data-testid="trade-card-get-offer">
        <div className="flex items-center gap-xl">
          <div className="shrink-0">
            <TradeIn aria-hidden="true" size={56} color={icon.inverse} />
          </div>
          <DefaultCardContent>
            <DefaultCardHeading>Sell/Trade your car</DefaultCardHeading>
            <DefaultCardBody>
              Get a real offer in less than 2 minutes. Sell, trade or track your
              value.
            </DefaultCardBody>
          </DefaultCardContent>
        </div>

        <NavigableButton
          href={ctaHref}
          data-native-included={dataNativeIncluded}
          data-native-payload={dataNativePayload}
          data-analytics-id="Home feed card"
          data-analytics-attributes={JSON.stringify({
            ...commonCustomAttributes,
            item: 'cta button'
          })}
          data-testid="trade-card-cta-default"
          onClick={onClick}
          size="sm"
          variant="primaryInverted"
          className="w-full"
        >
          Get Your Offer
        </NavigableButton>
      </DefaultCardContainer>
    </TrackWrapper>
  );
}
